import { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Translation from '@s/Translation';
import { connect } from 'react-redux'
import { isKioskMode } from 'checkout/selectors/ui';
import { secondsTohhmmss } from 'helpers/time';
import { extendTime } from '../../../actions/reservation';
import { CheckoutModal } from './CheckoutModal';
import Button from '@s/Button';
import { setCheckoutOverlay } from '@b/checkout/actions/ui';

export const TIME_REMAINING_THRESHOLD = 60; //set to 6000 for test

class MoreTimeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      close: false,
    };
  }

  onClose = () => {
    if (window.frameElement && window.parent) {
      window.parent.sessionStorage.setItem('moreTimeModalClosed', 'true');
      this.props.setCheckoutOverlay(false);
    }
    this.setState({ close: true });
  }

  onExtend = () => {
    this.props.extendTime();
    if (window.frameElement && window.parent) {
      this.props.setCheckoutOverlay(false);
    }
  }

  render() {
    if (this.state.close ||
      !this.props.allowExtendTime ||
      this.props.timeRemainingExtended ||
      this.props.isKioskMode ||
      this.props.timeRemaining > TIME_REMAINING_THRESHOLD ||
      this.props.timeRemaining <= 0) {
      return null;
    }

    return (
      <CheckoutModal open={true} onClose={this.onClose} backdrop>
        <CheckoutModal.Header>
          <CheckoutModal.Title>
            <Translation>{"checkout__do_you_need_more_time"}</Translation>
          </CheckoutModal.Title>
        </CheckoutModal.Header>
        <CheckoutModal.Body padding='md'>
          <div className="message__text message__text--align-left">
            <Translation interpolation={{
                time: secondsTohhmmss(this.props.timeRemaining),
                spanStart: '<span class="danger-text">',
                spanEnd: '</span>'
              }}>
                {"checkout__your_reservation_will_expire"}
            </Translation>
          </div>
        </CheckoutModal.Body>
        <CheckoutModal.Footer>
          <Button onClick={this.onClose} className="button--secondary button--full button--medium"><Translation>{"checkout__no"}</Translation></Button>
          <Button onClick={this.onExtend} className="button--primary button--full button--medium"><Translation>{"checkout__yes"}</Translation></Button>
        </CheckoutModal.Footer>
      </CheckoutModal>
    );
  }
};

MoreTimeModal.propTypes = {
  allowExtendTime: PropTypes.bool,
  isKioskMode: PropTypes.bool,
  timeRemaining: PropTypes.number,
  timeRemainingExtended: PropTypes.bool,
  extendTime: PropTypes.func
};

const mapStateToProps = state => {
  return {
    timeRemaining: state.reservation.time_remaining,
    allowExtendTime: state.reservation.allow_extend_time,
    timeRemainingExtended: state.reservation.time_remaining_extended,
    isKioskMode: isKioskMode(state),
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    extendTime,
    setCheckoutOverlay
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MoreTimeModal)

